'use strict';

const pageChangeTypeEnum = require('./pageChangeTypeEnum');


/**
 * Helper to set the transform property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transform CSS string to add vendor prefixes to.
 */
function setTransformStyle(style, transform) {
    style.transform = transform;
    style.WebkitTransform = transform;
}

/**
 * Helper to set the transition property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transition CSS string to add vendor prefixes to.
 */
function setTransitionStyle(style, transition) {
    style.transition = transition;
    style.WebkitTransition = '-webkit-' + transition;
}

/**
 * Simple helper to set the width of items.
 * @param {[type]} style [description]
 * @param {[type]} width [description]
 */
function setWidthStyle(style, width) {
    // Need both min and max width for this to work consistently.
    style.minWidth = `${width}%`;
    style.maxWidth = `${width}%`;
}

/**
 * Calculate the total number of pages in a paged carousel.
 * @param  {Number} itemCount    Total number of items in the carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getTotalPages(itemCount, itemsPerPage) {
    return Math.ceil(itemCount / Math.floor(itemsPerPage));
}

/**
 * Get the default width pf items in a paged carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getPagedItemWidth(itemsPerPage) {
    return 100 / itemsPerPage;
}

/**
 * Get the width of each item when the last on is going to be partially hidden. The `numerator` and `denominator`
 * indicate how much of the last item should be hidden.  So calling `getScrollableItemWidth(2, 1, 3)` indicatedsthat 2
 * items will be shown and the second one will be one third hidden.
 * @param  {Number} numItems The number of items to display on the page.
 * @param  {Number} numerator The numerator of the portion to hide.
 * @param  {Number} denominator The denominator of the portion to hide.
 * @return {Number}
 */
function getScrollableItemWidth(numItems, numerator, denominator) {
    return 100 / (numItems - (numerator / denominator));
}

/**
 * Calculate the default position of a paged carousel based on the current page.
 * @param {Number} page         The current page.
 * @return {Number}
 */
function getPagedOffset(page) {
    return -100 * page;
}



module.exports = {
    pageChangeTypeEnum,
    setTransformStyle,
    setTransitionStyle,
    setWidthStyle,
    getTotalPages,
    getPagedItemWidth,
    getScrollableItemWidth,
    getPagedOffset
};



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/utils/index.es.js